import { Box, Button, ButtonGroup } from "@mui/material";
import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import PatientDetails from "./PatientDetails/PatientDetails";
import PatientList from "./PatientList/PatientList";

const PatientManager = () => {
  const dispatch = useDispatch();
  // useRef
  const billCalculationReset = useRef();
  const newPatientReset = useRef();
  const reloadPatientList = useRef();
  const billListRef = useRef();
  const dueListRef = useRef();
  // useRef //
  // states
  const [isViewPatientList, setIsViewPatientList] = useState(true);
  const [pageLabe, setPageLabel] = useState("PATIENT LIST");
  // states //

  // methods
  const handleOpenPatientDetails = (patientId) => {
    setPageLabel("PATIENT DETAILS");
    console.log(patientId);
    dispatch({
      type: "patientId_add",
      payload: patientId,
    });
    dispatch({
      type: "loadPatientDetails_add",
      payload: true,
    });
    dispatch({
      type: "isNewPatient",
      payload: true,
    });
    dispatch({
      type: "transactionList_loadData",
      payload: [],
    });
    dispatch({
      type: "cartItems_reset",
    });
    dispatch({
      type: "orderId_remove",
    });
    dispatch({
      type: "orderId_remove",
    });
    setIsViewPatientList(false);
    //
    newPatientReset.current.getPatientDetailsById(patientId);
    billListRef.current.getOrderListByPatientId(patientId)
    dueListRef.current.getDueOrderList(patientId) // 
  };
  

  const hanldeNewPatient = () => {

  

    setPageLabel("NEW PATIENT");
    dispatch({
      type: "isNewPatient",
      payload: true,
    });
    dispatch({
      type: "transactionList_loadData",
      payload: [],
    });
    setIsViewPatientList(false);
    // state
    billCalculationReset.current.resetFormBillCalculation();
    newPatientReset.current.resetFormData();
  };
  const handlePatientList = () => {
    setPageLabel("PATIENT LIST");
    dispatch({
      type: "isNewPatient",
      payload: false,
    });
    setIsViewPatientList(true);
    reloadPatientList.current.getPatientList();
  };

  return (
    <>
      {/* TOP BUTTONS  */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {/* <Box>
          <Button variant="outlined"> {pageLabe} </Button>
        </Box> */}
        <Box sx={{ fontSize: "30px", marginBottom: 3, marginTop: 3 }}>
          {pageLabe}
        </Box>
        <Box>
          <ButtonGroup variant="contained" aria-label="outlined button group">
            <Button color="success" onClick={() => handlePatientList()}>
              PATIENT LIST
            </Button>
            <Button color="warning" onClick={() => hanldeNewPatient()}>
              NEW PATIENT
            </Button>
          </ButtonGroup>
        </Box>
      </Box>
      {/* TOP BUTTONS //  */}
      <Box sx={{ display: isViewPatientList ? "block" : "none" }}>
        {/* table  */}
        <PatientList
          handleOpenPatientDetails={handleOpenPatientDetails}
          ref={reloadPatientList}
        ></PatientList>
        {/* table // */}
      </Box>
      <Box sx={{ display: !isViewPatientList ? "block" : "none" }}>
        <PatientDetails
          ref={{
            billCalculationReset,
            newPatientReset,
            billListRef, 
            dueListRef, 
          }}
        ></PatientDetails>
      </Box>
    </>
  );
};

export default PatientManager;
